import React from "react";
import { useTranslation } from "react-i18next";
import { BsArrowLeft } from "react-icons/bs";
import { useNavigate, useSearchParams } from "react-router-dom";
import LanguageDropdown from "./LanguageDropdown";

export default function Header({
  setCurrentScreen,
  currentScreen,
  isCreditScoreCheck,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const headerTitle = () => {
    if (currentScreen === 0) return t("addcustomerstep1.BasicDetails");
    else if (currentScreen === 1) return t("addcustomerstep2.OTPVer");
    else if (currentScreen === 2) return t("pannumbersubmitpage.PANSub");
    else if (currentScreen === 3)
      return t("addcustomertotalinformation.otherDetails");
    else if (currentScreen === 4) return 'Consent review';
    else if(sessionStorage.getItem("isCreditScoreCheck")) return t("creditScore.results")
    else return "Recommendations";
  };

  return (
    <div
      className="header"
      style={{
        boxShadow: "0px 1px 12px 8px rgba(0, 0, 0, 0.05)",
        marginBottom: "20px",
        padding: "30px 10px",
        display: "flex",
      }}
    >
      {currentScreen !== 0 && (
        <BsArrowLeft
          onClick={() => {
            currentScreen === 1 || currentScreen === 2
              ? setCurrentScreen(0)
              : isCreditScoreCheck || sessionStorage.getItem("isCreditScoreCheck")
              ? navigate(
                  `/customer/generatecreditreport?hash=${encodeURIComponent(
                    searchParams.get("hash")
                  )}`
                )
              : navigate(
                  `/customer?hash=${encodeURIComponent(
                    searchParams.get("hash")
                  )}`
                );
            window?.Moengage?.track_event("add-customer_customer_back_button");
          }}
          style={{
            fontWeight: "bold",
          }}
        />
      )}

      <div
        style={{
          fontWeight: "500",
        }}
      >
        {headerTitle()}
      </div>
      {currentScreen === 0 ? (
        <div>
          <LanguageDropdown />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
